export default __webpack_public_path__ + "static/subZjD3d-de069439c3debf96696950a0bab6954e.jpeg";